import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CaptchaComponent} from './captcha.component';
import {IonicModule} from '@ionic/angular';
import {FormsModule} from '@angular/forms';



@NgModule({
  declarations: [CaptchaComponent],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
  ],
  exports: [
    CaptchaComponent,
  ],
})
export class CaptchaModule { }
